// extracted by mini-css-extract-plugin
export default {"wrapper":"banner_wrapper__fjA15","error":"banner_error__WPsqL","info":"banner_info__WB1wH"};